export default __webpack_public_path__ + "static/media/1_6_logo.ae638ffa.png";